import React from "react";
import {
  Box,
  Typography,
  IconButton,
  Divider,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";

const CustomizeHeader = ({ toggleDrawer, editItem }) => {
  const menuItems = [
    { id: "logo", title: "Logo" },
    { id: "search", title: "Search" },
    { id: "items", title: "Items" },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        height: "600px",
        // border: "1px solid #ccc",
        backgroundColor: "#fff",
        borderRadius: "4px",
        overflow: "hidden",
        // boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      }}
    >
      {/* Header Section */}
      <Box
        sx={{
          backgroundColor: "#333",
          color: "#fff",
          padding: "10px",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold", fontSize: "16px" }}>
          Customize Header Menu
        </Typography>
      </Box>

      {/* CustomizeHeader List */}
      <List>
        {menuItems.map((item, index) => (
          <React.Fragment key={index}>
            <ListItem
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "6px 10px", // Reduced padding for smaller height
              }}
            >
              <ListItemText primary={item.title} />
              <IconButton
                onClick={() => {
                  toggleDrawer(editItem.open, null, item.id);
                }}
              >
                <ArrowRightAltIcon /> {/* Changed the icon */}
              </IconButton>
            </ListItem>
            {index <= menuItems.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </List>
    </Box>
  );
};

export default CustomizeHeader;
